/**
 * Supporter prompt subcomponent
 */

import React from 'react';
import styled from 'styled-components';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import { green500 } from 'styles/colors';
import messages from './messages';

const AlertWrapper = styled.div`
  border: 1px solid ${green500};
`;

function SupporterPrompt() {
  return (
    <AlertWrapper className="p-4 mx-sm-5 my-3">
      <div className="mb-4 mx-sm-4">
        <FormattedHTMLMessage {...messages.supporterText} />
      </div>
      <div className="text-center my-3">
        <Button bsStyle="success" href="#subscription">
          <FormattedMessage {...messages.supporterAction} />
        </Button>
      </div>
    </AlertWrapper>
  );
}

export default SupporterPrompt;
